/** @format */

import React from "react";
import "../../styles/centralised-plan/layouts.css";

const LightTable = ({ columns, data }) => {
  return (
    <div className="table-responsive-k table-wrapper-k">
      <table className="light-table-k">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>
                <div className="flex-k textAlignCenter">{column.text}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(data) && data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <td key={colIndex}>
                  <div>
                    {column.formatter
                      ? column.formatter(row[column.dataField], row)
                      : row[column.dataField]}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LightTable;
